module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"way-control":"Назначить вагон на путь","select-way":"Выбрать путь"},"en":{"way-control":"Way control","select-way":"Select way"}}')
  delete Component.options._Ctor
}
